export default __webpack_public_path__ + "static/globalmap2022-2-01-fr-1074b03ab5c571d6f3ab8ed6ef00065e.svg";